//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'

import ImageViewer from '../../components/Images/ImageViewer.vue'
import ImageFilePreview from './ImageFilePreview.vue'
import FilePreview from './FilePreview.vue'
import DraggableFilesFieldTreeNode from './DraggableFilesFieldTreeNode.vue'
import { downloadFile } from '../helpers.js'
import { isFileAllowed, getFileOriginalTime, getFileOriginalHash, rotateImages, isImageDocument, isPdfDocument, isDocxDocument, isDocDocument, isTxtDocument, isVideoDocument } from './FileUtils.js'
import pdfFileViewerPlugin from './PdfFileViewerPlugin.js'
import docTxtFileViewerPlugin from './DocTxtFileViewerPlugin.js'
import videoViewerPlugin from './VideoViewerPlugin.js'
import { FileDocument } from './FileDocument.js'
import { SUPPORTED_VIDEO_TYPES } from './VideoViewer.vue'
import { UPLOAD_CONFIG } from '../../axios/axios.js'

Vue.use(pdfFileViewerPlugin)
Vue.use(docTxtFileViewerPlugin)
Vue.use(videoViewerPlugin)
Vue.use(Vue2TouchEvents)

function delay (fn) {
  return function () {
    const args = arguments
    setTimeout(() => {
      fn.apply(this, args)
    }, 200)
  }
}

let componentCounter = 0

export default {
  components: {
    ImageViewer,
    ImageFilePreview,
    FilePreview,
    DraggableFilesFieldTreeNode
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    selectModeEdit: {
      type: Boolean,
      default: false
    },
    accessToAdd: {
      type: Boolean,
      default: null
    },
    accessToRemove: {
      type: Boolean,
      default: null
    },
    accessToRotate: {
      type: Boolean,
      default: null
    },
    showBtnRemove: {
      type: Boolean,
      default: false
    },
    hideBtnAdd: {
      type: Boolean,
      default: false
    },
    treeView: {
      type: Boolean,
      default: false
    },
    listView: {
      type: Boolean,
      default: false
    },
    contentType: {
      type: String,
      default: null
    },
    singular: {
      type: Boolean,
      default: false
    },
    sizeLimit: {
      type: Number,
      default: null
    },
    original: {
      type: Boolean,
      default: false
    },
    textBeforeDownload: {
      type: String,
      default: 'Будут загружены:'
    },
    highlightErrors: {
      type: Boolean,
      default: false
    },
    calculateHash: {
      type: Boolean,
      default: false
    },
    showBtnMarker: {
      type: Object,
      default: null
    },
    showFilesIndex: {
      type: Boolean,
      default: false
    },
    showUploadFilesIndex: {
      type: Boolean,
      default: false
    },
    sizeImg: {
      type: Number,
      default: 140
    },
    disableDraggable: {
      type: Boolean,
      default: false
    },
    expansionFiles: {
      type: Boolean,
      default: false
    },
    filesGroupToCheckForIgnoreDuplicate: {
      type: Object,
      default: null
    },
    useMessengerUpload: {
      type: Boolean,
      default: false
    },
    askDeleteConfirmation: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      componentIndex: ++componentCounter,
      lastSelectedFile: null,
      selectedTreeNodeLabel: null,
      filesToPaste: null,
      contextMenuItems: null,
      dragUploadZone: null,
      hideFiles: true,
      affectedAndroid: false
    }
  },
  computed: {
    filesToDisplay: function () {
      if (this.expansionFiles && this.hideFiles) {
        return this.category.files.length ? [this.category.files[0]] : []
      }
      return this.category.files
    },
    inputId: function () {
      return this.category.key + '_UploadFilesInput_' + this.componentIndex
    },
    cameraInputId: function () {
      return this.inputId + '_camera'
    },
    usePhotoPickerChoice: function () {
      return this.imageContent && this.affectedAndroid && !this.hideBtnAdd
    },
    treeCmpUsed: function () {
      return this.category.filesTree && (this.treeView || this.listView)
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    treeClass: function () {
      return this.mobile ? 'files-field-tree' : 'files-field-tree files-field-tree--desktop'
    },
    inputAccept: function () {
      if (this.imageContent) {
        return 'image/*'
      } else if (this.videoContent) {
        return Array.from(UPLOAD_CONFIG.allowedVideoExtensions).join(',') // 'video/*'
      }
      return '*'
    },
    labelAddBtn: function () {
      if (this.imageContent) {
        return this.singular ? 'Добавить фотографию' : 'Добавить фотографии'
      } else if (this.videoContent) {
        return 'Добавить видео'
      }
      return this.singular ? 'Добавить файл' : 'Добавить файлы'
    },
    imageContent: function () {
      return this.contentType === 'image'
    },
    videoContent: function () {
      return this.contentType === 'video'
    },
    filePreviewCmp: function () {
      return this.treeCmpUsed ? null : this.imageContent ? ImageFilePreview : FilePreview
    },
    modeEditLocal: function () {
      return this.selectModeEdit && !this.category.readonly
    },
    accessToAddLocal: function () {
      return this.category.key && (this.accessToAdd !== false) && !this.category.readonly && this.sizeLeft !== 0
    },
    accessToRemoveLocal: function () {
      return this.category.key && (this.accessToRemove !== false) && !this.category.readonly
    },
    accessToRotateLocal: function () {
      return this.category.key && (this.accessToRotate || !this.category.readonly)
    },
    isDraggable: function () {
      return !this.disableDraggable
    },
    useTreeUploadZone: function () {
      return this.isDraggable && this.treeCmpUsed && this.category.filesTree.length == 0
    },
    useRowFieldUploadZone: function () {
      return this.isDraggable && !this.treeCmpUsed && this.accessToAddLocal && !this.mobile
    },
    getDragUploadZone: function () {
      if (this.useTreeUploadZone) {
        return this.$refs.tree.$el
      } else if (this.useRowFieldUploadZone) {
        return this.$refs.rowFieldUploadZone
      }
      return null
    },
    sizeLimitLocal: function () {
      if (this.singular) {
        return 1
      }
      return this.sizeLimit != null ? this.sizeLimit : null
    },
    sizeLeft: function () {
      if (this.sizeLimitLocal) {
        let sizeLeft = this.sizeLimitLocal - this.category.size
        if (sizeLeft < 0) {
          sizeLeft = 0
        }
        return sizeLeft
      }
      return null
    }
  },
  mounted: function () {
    this.$el.addEventListener('click', this.onFieldClick)
    this.$el.addEventListener('contextmenu', this.onContextMenu)
    this.dragUploadZone = this.getDragUploadZone
    this.addDragAndDropUpload()
    this.$d.isAndroidPhotoPickerAffected().then(affectedAndroid => {
      this.affectedAndroid = affectedAndroid
    })
  },
  updated: function () {
    this.removeDragAndDropUpload()
    this.dragUploadZone = this.getDragUploadZone
    this.addDragAndDropUpload()
  },
  beforeDestroy: function () {
    this.$el.removeEventListener('click', this.onFieldClick)
    this.$el.removeEventListener('contextmenu', this.onContextMenu)
    this.removeDragAndDropUpload()
  },
  methods: {
    onRotate: function (image) {
      if (this.accessToRotateLocal && image) {
        rotateImages([image])
      }
    },
    addDragAndDropUpload: function () {
      if (this.dragUploadZone) {
        this.dragUploadZone.addEventListener('dragover', this.onDragOver)
        this.dragUploadZone.addEventListener('dragend', this.onDragEnd)
        this.dragUploadZone.addEventListener('drop', this.onDrop)
        this.dragUploadZone.addEventListener('dragenter', this.onDragEnter)
        this.dragUploadZone.addEventListener('dragleave', this.onDragLeave)
      }
    },
    removeDragAndDropUpload: function () {
      if (this.dragUploadZone) {
        this.dragUploadZone.removeEventListener('dragover', this.onDragOver)
        this.dragUploadZone.removeEventListener('dragend', this.onDragEnd)
        this.dragUploadZone.removeEventListener('drop', this.onDrop)
        this.dragUploadZone.removeEventListener('dragenter', this.onDragEnter)
        this.dragUploadZone.removeEventListener('dragleave', this.onDragLeave)
      }
    },
    onDragOver: function (e) {
      e.preventDefault()
    },
    onDragEnter: function (e) {
      this.setDraggedStyle(this.dragUploadZone)
    },
    onDragLeave: function (e) {
      const dropZoneCoords = this.dragUploadZone.getBoundingClientRect()
      if (e.clientX > dropZoneCoords.right || e.clientX < dropZoneCoords.left || e.clientY > dropZoneCoords.bottom || e.clientY < dropZoneCoords.top) {
        this.setDefaultStyle(this.dragUploadZone)
      }
    },
    onDrop: function (e) {
      e.preventDefault()
      e.stopPropagation()

      this.setDefaultStyle(this.dragUploadZone)

      if (e.dataTransfer.files.length !== 0) {
        this.addFilesToUpload(e)
      }
    },
    onDragEnd: function (e) {
      this.setDefaultStyle(this.dragUploadZone)
    },
    setDefaultStyle: function (targetElement) {
      targetElement.style.backgroundColor = 'unset'
    },
    setDraggedStyle: function (targetElement) {
      targetElement.style.backgroundColor = '#f2f2f2'
    },

    onTouchHoldFile: function (event, file) {
      if (event.type === 'touchstart') { // для десктопной версии всплывает mousedown
      // if (this.mobile) {
        this.onChangeFileSelection(file)
      }
    },
    onContextMenuFile: function (event, file) {
      event.preventDefault()
      event.$d_file = file
      if (event.type !== 'contextmenu') {
        this.onSelectFile(file)
        this.onContextMenu(event)
      }
    },
    onContextMenu: function (event) {
      event.preventDefault()
      const target = event.target || event.path[0]

      let file = null
      const contextMenuItems = []
      if (this.treeCmpUsed) { // classList
        if (target.classList.contains('files-field') || target.classList.contains('files-field-tree')) { // classList
          console.log('FilesField: ROOT')

          if (!this.category.readonly) {
            if (this.filesToPaste) {
              contextMenuItems.push({
                label: 'Вставить',
                fn: () => this.onPastFile()
              })
            }
            contextMenuItems.push({
              label: 'Создать папку',
              fn: () => this.onAddFolder()
            })
            contextMenuItems.push({
              label: 'Добавить файл(ы)',
              fn: () => this.onAddFile()
            })
          }

          if (contextMenuItems.length) {
            contextMenuItems.push({ separator: true })
          }
          contextMenuItems.push({
            label: 'Развернуть все',
            fn: () => this.expandAll()
          })
          contextMenuItems.push({
            label: 'Свернуть все',
            fn: () => this.collapseAll()
          })
        } else {
          file = this.getFileFromElement(target, 'files-field-tree-node')
          console.log('FilesField: ' + (file ? 'file' : 'other element'))
          if (file) {
            if (!this.category.readonly) {
              if (this.filesToPaste && file.type === 'folder') {
                contextMenuItems.push({
                  label: 'Вставить',
                  fn: () => this.onPastFile(file._node)
                })
              }
              contextMenuItems.push({
                label: 'Вырезать',
                fn: () => this.onCutFile(file._node)
              })
              if (file.parent && file.parent.id !== -1) {
                contextMenuItems.push({
                  label: 'Переместить в корень',
                  fn: () => this.onMoveFileToRoot()
                })
              }
            }

            if (!this.category.readonly && file.type === 'folder') {
              contextMenuItems.push({ separator: true })
              contextMenuItems.push({
                label: 'Создать папку',
                fn: () => this.onAddFolder()
              })
              contextMenuItems.push({
                label: 'Добавить файл(ы)',
                fn: () => this.onAddFile()
              })
            }

            if (file.type !== 'folder') {
              contextMenuItems.push({ separator: true })
              if (this.hasViewer(file)) {
                contextMenuItems.push({
                  label: 'Открыть',
                  fn: () => this.onShowFile(file)
                })
              }
              contextMenuItems.push({
                label: 'Скачать',
                fn: () => this.onDownloadFile(file)
              })
              contextMenuItems.push({
                label: 'Скачать архивом',
                fn: () => this.onDownloadFilesInArchive()
              })

              contextMenuItems.push({ separator: true })
              contextMenuItems.push({
                label: 'Копировать путь',
                fn: () => this.onCopyPathToFile(file)
              })
              if (file && file.url) {
                contextMenuItems.push({
                  label: 'Копировать ссылку на скачивание',
                  fn: () => this.onCopyUrlToDownloadFile(file)
                })
              }
            }

            if (!this.category.readonly) {
              contextMenuItems.push({ separator: true })
              contextMenuItems.push({
                label: 'Переименовать',
                fn: () => this.onRenameFileOrFolder(file)
              })

              contextMenuItems.push({
                label: 'Удалить',
                fn: () => this.onDeleteSelectedFiles()
              })
            }

            if (file.type === 'folder') {
              contextMenuItems.push({ separator: true })
              contextMenuItems.push({
                label: 'Развернуть все',
                fn: () => this.onExpandOrCollapseAllChildren(file, true)
              })
              contextMenuItems.push({
                label: 'Свернуть все',
                fn: () => this.onExpandOrCollapseAllChildren(file, false)
              })
            }
          }
        }
      } else if (target.classList.contains('file-preview') || target.classList.contains('file-preview-inner') || target.classList.contains('file-preview-inner-label')) {
        file = this.getFileFromElement(target, 'file-preview-wrapper')
        if (file) {
          if (this.hasViewer(file)) {
            contextMenuItems.push({
              label: 'Открыть',
              fn: () => this.onShowFile(file)
            })
          }
          if (file.url) {
            contextMenuItems.push({
              label: 'Скачать',
              fn: () => this.onDownloadFile(file)
            })
            contextMenuItems.push({
              label: 'Копировать ссылку на скачивание',
              fn: () => this.onCopyUrlToDownloadFile(file)
            })
          }
        }
      } else if (event.$d_file) {
        file = event.$d_file
        if (file) {
          if (this.hasViewer(file)) {
            contextMenuItems.push({
              label: 'Открыть',
              fn: () => this.onShowCategoryPhotos(file)
            })
          }
          if (file.url) {
            contextMenuItems.push({
              label: 'Скачать',
              fn: () => this.onDownloadFile(file)
            })
            contextMenuItems.push({
              label: 'Копировать ссылку на скачивание',
              fn: () => this.onCopyUrlToDownloadFile(file)
            })
          }
        }
      }
      this.contextMenuItems = contextMenuItems

      if (contextMenuItems.length) {
        if (this.$refs.contextMenu.showing) {
          this.$refs.contextMenu.hide()
          this.$nextTick(() => {
            this.$refs.contextMenu.show(event)
          })
        } else {
          this.$refs.contextMenu.show(event)
        }
      } else {
        if (this.$refs.contextMenu.showing) {
          this.$refs.contextMenu.hide()
        }
      }

      if (file && !file.selected && this.selectModeEdit) {
        this.onSelectSingleFile(file)
      }
    },
    getFileFromElement: function (target, previewClass) {
      let file = null
      for (let element = target; element != null; element = element.parentNode || null) {
        if (element.classList.contains(previewClass)) {
          file = element.__vue__.file
          break
        } else if (element.classList.contains('files-field')) {
          break
        }
      }
      console.log('File: ', file)
      return file
    },
    onFieldClick: function (event) {
      if (this.$refs.contextMenu) {
        if (this.$refs.contextMenu.showing) {
          this.$refs.contextMenu.hide()
        }
      }

      const target = event.target || event.path[0]
      if (target.classList.contains('files-field') || target.classList.contains('files-field-tree')) { // classList
        this.category.clearSelection()
      }
    },

    onAddFolder: function () {
      this.$emit('edit-start')
      return new Promise((resolve, reject) => {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              const fileWrapper = this.category.addFolder(data.name)
              this.expandParent(fileWrapper)

              resolve(fileWrapper)
            } else {
              resolve(null) // reject
            }
          },
          header: this.category.title ? `«${this.category.title}»\nСоздание папки` : 'Создание папки',
          propsConfig: {
            name: { type: 'text', label: 'Название', required: true, autofocus: true, autogrow: false }
          },
          buttons: [
            { key: 'yes', name: 'Подтвердить' },
            { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
          ]
        })
      }).finally(() => {
        this.$emit('edit-end')
      })
    },
    onAddFile: function () {
      const inputEl = document.getElementById(this.inputId)
      inputEl.click()
    },
    onTakePhoto: function () {
      const inputEl = document.getElementById(this.cameraInputId)
      if (inputEl) {
        inputEl.click()
      }
    },
    onRenameFileOrFolder: function (file) {
      this.$emit('edit-start')
      return new Promise((resolve, reject) => {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              file.name = data.name
              this.category.filesToUpdate.push(file)

              resolve(true)
            } else {
              resolve(false)
            }
          },
          header: 'Переименовать',
          propsConfig: {
            name: { type: 'text', label: 'Название', required: true, value: file.name, autofocus: true, autogrow: false }
          },
          buttons: [
            { key: 'yes', name: 'Подтвердить' },
            { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
          ]
        })
      }).finally(() => {
        this.$emit('edit-end')
      })
    },
    getFileFromEntry: async function (entry) {
      return new Promise((resolve, reject) => {
        entry.file(function (result) {
          resolve(result)
        })
      })
    },
    addFilesToUpload: async function (event) {
      let newFiles = []
      if (event.type.includes('drop')) {
        const items = event.dataTransfer.items
        for (let i = 0; i < items.length; i++) {
          try {
            newFiles.push(items[i].webkitGetAsEntry())
          } catch (err) {
            this.$q.notify({
              type: 'error',
              message: err.message,
              progress: true,
              timeout: 8000
            })
          }
        }
      } else {
        newFiles = event.target.files
      }
      if (newFiles.length && this.sizeLeft != null && this.sizeLeft < newFiles.length) {
        newFiles = [...newFiles].slice(0, this.sizeLeft)

        this.$q.notify({
          type: 'warning',
          message: 'Максимальное число файлов - ' + this.sizeLimitLocal,
          progress: true,
          timeout: 5000
        })
      }
      if (newFiles.length) {
        for (let i = 0; i < newFiles.length; i++) {
          let file = null
          const item = newFiles[i]
          console.log(item)
          if (item instanceof File) {
            file = item
          } else {
            if (item.isFile && !item.isDirectory) {
              file = await this.getFileFromEntry(item)
            } else {
              this.$q.notify({
                type: 'warning',
                message: 'Добавление папок перетаскиванием невозможно',
                progress: true,
                timeout: 8000
              })
              continue
            }
          }

          // TODO: file system api - read and add folders
          const result = isFileAllowed(file, this.imageContent, this.videoContent)
          if (!result.result) {
            this.$q.notify({
              type: 'negative',
              message: result.message,
              progress: true,
              timeout: 4000
            })
            continue
          }

          const fileWrapper = new FileDocument(file, {
            originalTime: await getFileOriginalTime(file),
            originalHash: this.calculateHash ? await getFileOriginalHash(file) : null,
            onSuccess: (response) => {
              this.deleteFileFromUpload(fileWrapper)

              const document = response.data.result || null
              const filesGroup = this.category
              if (document) {
                filesGroup.pushFile(document)
              }

              this.$emit('upload-success', { document, filesGroup, fileWrapper })
            },
            onFailure: (response) => {
              const duplicate = response && response.code === 'duplicate'
              if (duplicate && !this.highlightErrors) {
                this.deleteFileFromUpload(fileWrapper)
              } else {
                fileWrapper.uploadError = response
                this.$emit('upload-failure', response)
              }
            }
          })

          if (event.targetFolder) {
            this.category.addFileToFolder(fileWrapper, this.category.getFolder(event.targetFolder))
          } else {
            this.category.addFile(fileWrapper)
          }

          if (this.filesGroupToCheckForIgnoreDuplicate) {
            this.checkForIgnoreDuplicate(fileWrapper)
          }

          this.expandParent(fileWrapper)
          this.$emit('add', fileWrapper, this.category)
          if (this.videoContent && !SUPPORTED_VIDEO_TYPES.includes(fileWrapper.file.type)) {
            this.$q.notify({
              type: 'warning',
              message: `Предпросмотр видеофайла ${fileWrapper.name} недоступен`,
              progress: true,
              timeout: 4000
            })
          }
        }

        const inputEl = document.getElementById(this.inputId)
        if (inputEl) {
          inputEl.value = ''
        }
        const cameraInputEl = document.getElementById(this.cameraInputId)
        if (cameraInputEl) {
          cameraInputEl.value = ''
        }
      }
    },
    checkForIgnoreDuplicate: function (fileWrapper) {
      const duplicates = []
      duplicates.push(...this.filesGroupToCheckForIgnoreDuplicate.filesToUpload.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))
      duplicates.push(...this.filesGroupToCheckForIgnoreDuplicate.files.filter(fileWrapperAnother => fileWrapper.checkDuplicate(fileWrapperAnother)))

      if (duplicates.length) {
        fileWrapper.ignoreDuplicate = true
      }
      return duplicates
    },
    expandParent: function (fileWrapper) {
      if (fileWrapper && fileWrapper.parent) {
        this.expandFolder(fileWrapper.parent)
      }
    },
    expandFolder: function (fileWrapper) {
      if (fileWrapper && fileWrapper.id !== -1) {
        this.$nextTick(() => this.$nextTick(() => {
          this.$refs.tree.setExpanded(fileWrapper._node.nodeKey, true)
        }))
      }
    },
    onExpandOrCollapseAllChildren: function (fileWrapper, expand) {
      if (fileWrapper && fileWrapper.id !== -1) {
        this.$refs.tree.setExpanded(fileWrapper._node.nodeKey, expand)
      }
      if (fileWrapper._node.children && fileWrapper._node.children.length) {
        fileWrapper._node.children.forEach(node => {
          this.onExpandOrCollapseAllChildren(node._file, expand)
        })
      }
    },
    expandAll: function () {
      this.$refs.tree.expandAll()
    },
    collapseAll: function () {
      this.$refs.tree.collapseAll()
    },
    onDoubleClickFile: function (file, event) {
      if (this.treeCmpUsed) {
        if (file.type !== 'folder') {
          this.onShowFile(file)
        } else {
          this.expandFolder(file)
        }
      }
    },
    onShowCategoryPhotos: function (file) {
      const files = this.category.files
      const index = files.indexOf(file)
      this.$refs.viewer.show(files, index)
    },
    onShowFile: function (file) {
      if (this.hasViewer(file)) {
        if (isImageDocument(file)) {
          if (file.isToUpload) {
            file = {
              url: file.file.blob,
              name: file.name
            }
          }
          this.$refs.viewer.show([file], this.showFilesIndex ? file.indexOf(file) + 1 : 0)
        } else if (isPdfDocument(file)) {
          this.$d_pdfViewer.show({ files: [{ src: file }] })
        } else if (isDocxDocument(file)) {
        /* const downloadUrl = file.url + (this.original ? '&original=true' : '')
        const convertedFile = new File([file], file.name)
        convertedFile.url = '/service/fileobj/read/' + file.id + '?convert=pdf'
        this.$d_pdfViewer.show({ files: [{ src: convertedFile, downloadLink: downloadUrl }] }) */
          this.$d_docTxtViewer.show(file)
        } else if (isDocDocument(file) || isTxtDocument(file)) {
          this.$d_docTxtViewer.show(file)
        } else if (isVideoDocument(file)) {
          const videoUrl = file.url.startsWith('blob:') ? file.url : '/service/fileobj/read/' + file.id + '?streamVideo=true'
          this.$d_videoViewer.show(file.id, file.name, videoUrl)
        }
      } else if (file.type !== 'folder') {
        this.notifyFileHasNotViewer()
      }
    },
    hasViewer: function (file) {
      return file && (isImageDocument(file) || isPdfDocument(file) || isDocxDocument(file) || isDocDocument(file) || isTxtDocument(file) || isVideoDocument(file) && SUPPORTED_VIDEO_TYPES.includes(file.contentType))
    },
    onClickFile: function (file, event) {
      if (this.selectModeEdit) {
        if (!event || event.ctrlKey) {
          this.onChangeFileSelection(file)
        } else if (event.shiftKey) {
          const lastSelectedFile = this.lastSelectedFile// this.category.selectedFiles[this.category.selectedFiles.length - 1]
          if (!lastSelectedFile || lastSelectedFile === file) { // this.category.selectedFiles.length === 0
            this.onSelectFile(file)
          } else if (lastSelectedFile.type === 'folder') {
            this.onChangeFileSelection(file)
          } else if (file.parent.id === lastSelectedFile.parent.id) {
            const parentChildren = file.parent._node.children
            const fileIndex = parentChildren.indexOf(file._node)
            const lastSelectedFileIndex = parentChildren.indexOf(lastSelectedFile._node)
            let filesNodesToSelect
            if (lastSelectedFileIndex < fileIndex) {
              filesNodesToSelect = parentChildren.slice(lastSelectedFileIndex + 1, fileIndex + 1)
            } else {
              filesNodesToSelect = parentChildren.slice(fileIndex, lastSelectedFileIndex).reverse()
            }
            filesNodesToSelect.map(node => node._file).filter(file => file.type !== 'folder').forEach(file => {
              this.onSelectFile(file)
            })
            this.onSelectFile(lastSelectedFile)

            // TODO Отменить выделение элементов пересекающейся группы файлов
          } else {
            // Некорректное нажатие
          }
        } else {
          this.onSelectSingleFile(file)
        }
      } else {
        if (this.imageContent) {
          this.onShowCategoryPhotos(file)
        } else if (this.category.selectedFiles.length) {
          this.onChangeFileSelection(file)
        } else {
          this.onShowFile(file)
        }
      }

      this.$emit('click-file', file)

      if (file.type === 'folder') {
        console.log(JSON.stringify(file.folder))
      }
      // console.log('U: ' + this.category.filesToUpload.map(file => file.name).join(', '))
      // console.log('D: ' + this.category.filesToDelete.map(file => file.name).join(', '))
    },
    onShowFileFromUpload: function (fileToShow, index) {
      if (this.imageContent) {
        this.$refs.viewer.show(this.category.filesToUpload, index)
      } else {
        if (this.hasViewer(fileToShow)) {
          this.onShowFile(fileToShow)
        } else if (fileToShow.type !== 'folder') {
          this.notifyFileHasNotViewer()
        }
      }
    },
    notifyFileHasNotViewer: function () {
      this.$q.notify({
        type: 'negative',
        message: 'Невозможно открыть файл для просмотра',
        progress: true,
        timeout: 8000
      })
    },

    onSelectSingleFile: function (file) {
      this.category.clearSelection()
      this.category.selectFile(file)
      this.lastSelectedFile = file
    },
    onSelectFile: function (file) {
      if (!file.selected) {
        this.category.selectFile(file)
      }
      this.lastSelectedFile = file
    },
    onChangeFileSelection: function (file) {
      if (this.category.selectedFiles.length && !file.selected && //
        (file.type === 'folder' || this.category.selectedFiles[0].type === 'folder') //
      ) {
        this.category.clearSelection()
      }
      this.category.selectFile(file)
      this.lastSelectedFile = file
      // console.log(this.category.selectedFiles.map(file => file.name).join(', '))
    },
    onDeleteFileImmediate: function (file) {
      // TODO
      // this.category.deleteFile(file)
      this.$emit('remove', {
        file: file,
        filesGroup: this.category
      })
    },
    onDeleteFiles: function () {
      this.category.deleteSelectedFiles()
    },
    deleteFileFromUpload: function (file) {
      this.category.deleteFile(file)
      this.$emit('remove-from-upload', file)
      // console.log('U: ' + this.category.filesToUpload.map(file => file.name).join(', '))
      // console.log('D: ' + this.category.filesToDelete.map(file => file.name).join(', '))
    },
    onDeleteFileFromUpload: function (file) {
      this.deleteFileFromUpload(file)
      this.$emit('delete-from-upload', file, this.category)
    },
    onCutFile: delay(function (node) {
      this.filesToPaste = this.category.selectedFiles.slice()
    }),
    onPastFile: delay(function (node) {
      if (!node) {
        node = this.category.getRoot()
      }
      this.category.moveFilesToFolder(this.filesToPaste, node._file)
      this.category.clearSelection()
      this.filesToPaste = null
      this.expandFolder(node._file)
    }),
    onMoveFileToRoot: delay(function () {
      const filesToPaste = this.category.selectedFiles.slice()
      this.category.moveFilesToFolder(filesToPaste, null)
      this.category.clearSelection()
    }),
    onDeleteSelectedFiles: function () {
      this.category.deleteSelectedFiles()
    },
    getPartsOfPathToFile: function (file) {
      if (!file) {
        return []
      }

      const isRootFolder = file.folder && file.folder.id === -1
      if (isRootFolder) {
        return []
      }

      const currentName = file.folder ? file.folder.name : file.document.name
      const parentPath = file.parent ? this.getPartsOfPathToFile(file.parent) : []

      return currentName ? [...parentPath, currentName] : parentPath
    },
    onCopyPathToFile: async function (file) {
      const parts = this.getPartsOfPathToFile(file)
      const pathToFile = parts.join('/')
      await navigator.clipboard.writeText(pathToFile)
    },

    /*********************************
     * Скачивание файлов
     */

    getUrlToDownloadFile: function (file) {
      if (file && file.url) {
        const urlParams = new URLSearchParams()
        if (this.original) {
          urlParams.append('original', true)
        }
        if (this.category.filesTree && this.treeView) {
          // if (file.parent) {
          //   urlParams.append('exportFolder', file.parent.id)
          // }
          if (file.name) {
            urlParams.append('exportName', file.name)
          }
        }
        const urlParamsString = urlParams.toString()
        return file.url + (urlParamsString ? '&' + urlParamsString : '')
      }
      return null
    },

    onCopyUrlToDownloadFile: async function (file) {
      const baseUrl = window.location.origin
      const fullUrl = new URL(this.getUrlToDownloadFile(file), baseUrl).toString()
      await navigator.clipboard.writeText(fullUrl)
    },

    /**
     * см. FilesPanel.downloadFiles()
     */
    onDownloadFiles: function () {
      const selectedFiles = this.category.selectedFiles
      if (selectedFiles && selectedFiles.length) {
        // TODO use helpers.js
        if (selectedFiles.length > 20) {
          throw new Error('Выбрано слишком много файлов: ' + selectedFiles.length + '. Максимальное количество - 20. Для загрузки большего количества файлов нужна выгрузка в архиве.')
        }
        const load = (index) => {
          this.onDownloadFile(selectedFiles[index])
          if (++index < selectedFiles.length) {
            setTimeout(() => {
              load(index)
            }, 50)
          }
        }
        load(0)
      }
    },

    /**
     * см. inv.downloadFilesInArchive
     */
    onDownloadFilesInArchive: function () {
      const selectedFiles = this.category.selectedFiles
      if (selectedFiles && selectedFiles.length) {
        if (selectedFiles.length > 1000) {
          this.$q.notify({
            type: 'negative',
            message: 'Выбрано слишком много файлов: ' + selectedFiles.length + '. Максимальное количество - 1000.',
            progress: true,
            timeout: 4000
          })
          return
        }

        this.onDownloadFileAsPost('service/fileobj/loadfiles', {
          id: selectedFiles.map(imageData => imageData.id).join(',')
        })
      }
    },

    /**
     * TODO см. inv.download()
     */
    onDownloadFile: function (file, onload, onerror) {
      const url = this.getUrlToDownloadFile(file)
      if (url) {
        downloadFile(url)
      }
    },

    /**
     * TODO см. inv.downloadPost()
     */
    onDownloadFileAsPost: function (uri, params) {
      const form = document.createElement('form')
      form.action = document.location.origin + (uri.startsWith('/') ? '' : '/') + uri
      form.method = 'post'
      if (params) {
        Object.entries(params).forEach(entry => {
          const input = document.createElement('input')
          input.name = entry[0]
          input.value = entry[1]
          form.append(input)
        })
      }

      function getCookie (name) {
        const matches = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
        return matches ? decodeURIComponent(matches[1]) : undefined
      }
      const token = getCookie('XSRF-TOKEN')
      if (token) {
        const csrf = document.createElement('input')
        csrf.name = '_csrf'
        csrf.value = token
        form.append(csrf)
      }

      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    }
  }
}
